<template>
    <div class="issue-badge-in-inspection-form">
        <div class="issue-badge-in-inspection-form-badge">
            <ReadinessBadge
            status="'Removed'"
            :dot="dot"
            :level="currentBadge"
            :view="'ReadOnly'"
            />
        </div>
        <div class="issue-badge-in-inspection-form-content">
            <ReadyForIndicator v-if="levelForDropdown" :level="levelForDropdown"/>
            <div class="issue-badge-in-inspection-form-dropdown-wrap">
                <GrandBadgeDropdown
                :value="currentBadge"
                :level="levelForDropdown"
                :hasActiveCheckpoints="hasActiveCheckpoints"
                @input="handleBadgeSelection"
                />
                <p class="issue-badge-clarification">Select an option to issue or award a badge. A badge is only given when you choose an action from this dropdown.</p>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import GrandBadgeDropdown from "@components/EvaluationGrandBadge/GrandBadgeDropdown.vue";
import ReadyForIndicator from "@components/ReadyForIndicator/ReadyForIndicator.vue";
import ReadinessBadge from "@components/ReadinessBadge/ReadinessBadge.vue";

const props = defineProps({
    dot: {
        type: String,
        required: true,
        default: "Good Standing",
    },
    currentBadge: {
        type: String,
        required: true,
        default: "Apprentice",
    },
    readyForLevel: {
        type: String,
        default: null,
    },
    /** Rule 13: this component only renders inside a responsibility inspection form. */
    hasActiveCheckpoints: {
        type: Boolean,
        default: true,
    },
});

const emit = defineEmits(['badge-selected']);

const selectedBadge = ref(null);

const levels = ['Apprentice', 'Professional', 'Coach', 'Master'];

const nextLevel = computed(() => {
    const currentIndex = levels.indexOf(props.currentBadge);
    
    if (currentIndex === -1 || currentIndex === levels.length - 1) {
        return null;
    }
    
    return levels[currentIndex + 1];
});

const levelForDropdown = computed(() => {
    if (props.readyForLevel && props.readyForLevel !== 'Novice') {
        const currentIndex = levels.indexOf(props.currentBadge);
        const readyForIndex = levels.indexOf(props.readyForLevel);
        
        if (readyForIndex > currentIndex) {
            return props.readyForLevel;
        }
    }
    
    return null;
});

const handleBadgeSelection = (badgeData) => {
    selectedBadge.value = badgeData?.value || null;
    emit('badge-selected', badgeData);
};
</script>

<style scoped>
.issue-badge-in-inspection-form {
    display: flex;
    flex-direction: column;
    align-items: end;
    gap: 20px;
    width: fit-content;
}

.issue-badge-in-inspection-form-content {
    display: flex;
    align-items: center;
    gap: 7px;
}

.issue-badge-in-inspection-form-dropdown-wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 6px;
}

.issue-badge-clarification {
    margin: 0;
    font-size: 12px;
    line-height: 1.35;
    color: #667085;
    max-width: 280px;
    text-align: right;
}
</style>